import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import InlineVideo from './InlineVideo';

const {
  FiPlay,
  FiFileText,
  FiExternalLink,
  FiCalendar,
  FiArrowRight
} = FiIcons;

const ContentMedia = ({ item }) => {
  if (item.type === 'video') {
    return <InlineVideo item={item} />;
  }

  return (
    <div className="relative aspect-video overflow-hidden bg-[#152b1d]">
      {item.image ? (
        <img
          src={item.image}
          alt=""
          loading="lazy"
          className="h-full w-full object-cover opacity-80 transition duration-300 group-hover:scale-105 group-hover:opacity-100"
        />
      ) : (
        <div className="flex h-full items-center justify-center text-[#658d71]">
          <SafeIcon icon={FiFileText} size={34} />
        </div>
      )}
    </div>
  );
};

const ContentCard = ({ item, matchedPlayers }) => {
  const navigate = useNavigate();
  const isVideo = item.type === 'video';

  return (
    <article className="group flex h-full flex-col overflow-hidden border border-[#658d71] bg-[rgba(0,0,0,0.12)] transition-all hover:-translate-y-0.5 hover:border-[#d8ceb3]">
      <div className="relative">
        <ContentMedia item={item} />
        <span className="pointer-events-none absolute left-2 top-2 flex items-center gap-1 bg-[#1e3a29]/95 px-2 py-1 text-[8px] font-black uppercase tracking-widest text-[#d8ceb3]">
          <SafeIcon icon={isVideo ? FiPlay : FiFileText} size={9} />
          {isVideo ? 'Video' : 'News'}
        </span>
      </div>

      <div className="flex flex-1 flex-col gap-3 p-3">
        <div>
          <h2 className="line-clamp-2 text-sm font-black uppercase leading-tight tracking-wide text-white">
            {item.title}
          </h2>
          {item.description && (
            <p className="mt-1 line-clamp-3 text-[10px] leading-relaxed text-[#a9c9b1]">
              {item.description}
            </p>
          )}
        </div>

        {matchedPlayers.length > 0 && (
          <div className="flex flex-wrap gap-1">
            {matchedPlayers.map((player) => (
              <span
                key={player.id}
                className="border border-[rgba(216,206,179,0.35)] bg-[rgba(216,206,179,0.08)] px-1.5 py-0.5 text-[8px] font-bold uppercase tracking-wider text-[#d8ceb3]"
              >
                {player.name}
              </span>
            ))}
          </div>
        )}

        <div className="mt-auto flex items-center gap-2 border-t border-[rgba(101,141,113,0.3)] pt-3">
          <span className="flex items-center gap-1 text-[8px] font-bold uppercase tracking-widest text-[#658d71]">
            <SafeIcon icon={FiCalendar} size={9} />
            {item.gameDate || '--'}
          </span>
          <span className="truncate text-[8px] font-black uppercase tracking-widest text-[#a9c9b1]">
            {item.matchup}
          </span>
        </div>

        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => navigate(`/game/pk/${item.gamePk}`)}
            className="flex flex-1 items-center justify-center gap-1 border border-[#658d71] px-2 py-1.5 text-[8px] font-black uppercase tracking-widest text-[#a9c9b1] transition-colors hover:bg-[#386646] hover:text-white"
          >
            Game
            <SafeIcon icon={FiArrowRight} size={9} />
          </button>

          {item.url && (
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-1 items-center justify-center gap-1 border border-[#d8ceb3] px-2 py-1.5 text-[8px] font-black uppercase tracking-widest text-[#d8ceb3] transition-colors hover:bg-[#d8ceb3] hover:text-[#1e3a29]"
            >
              {isVideo ? 'Watch on MLB' : 'Read on MLB'}
              <SafeIcon icon={FiExternalLink} size={9} />
            </a>
          )}
        </div>
      </div>
    </article>
  );
};

export default ContentCard;